import { getJWTToken } from '../utils/auth';
import { authHeaders } from './impersonation';

const apiUrl = import.meta.env.REACT_APP_BAMBOO_API_URL ?? '';

export type SetupConfirmation = { at: string; by: string };

export type SetupState = {
  sisRequestedAt: string | null;
  exitCriteriaConfirmed: SetupConfirmation | null;
  yearsConfirmed: SetupConfirmation | null;
};

type RawConfirmation = { at?: unknown; by?: unknown } | null | undefined;

type SetupStateBody = {
  sisRequestedAt?: unknown;
  exitCriteriaConfirmed?: RawConfirmation;
  yearsConfirmed?: RawConfirmation;
} | null;

export function asConfirmation(raw: RawConfirmation): SetupConfirmation | null {
  if (!raw || typeof raw.at !== 'string' || raw.at === '') return null;
  return { at: raw.at, by: typeof raw.by === 'string' ? raw.by : '' };
}

export function settingsConfirmed(state: SetupState): boolean {
  return state.exitCriteriaConfirmed !== null && state.yearsConfirmed !== null;
}

export async function fetchSetupState(): Promise<SetupState> {
  const token = await getJWTToken();
  const response = await fetch(`${apiUrl}/setup-state`, { headers: authHeaders(token) });
  if (!response.ok) {
    throw new Error(`setup-state failed: ${response.status}`);
  }
  const body = (await response.json()) as SetupStateBody;
  return {
    sisRequestedAt: typeof body?.sisRequestedAt === 'string' ? body.sisRequestedAt : null,
    exitCriteriaConfirmed: asConfirmation(body?.exitCriteriaConfirmed),
    yearsConfirmed: asConfirmation(body?.yearsConfirmed),
  };
}

export async function requestSisConnection(): Promise<void> {
  const token = await getJWTToken();
  const response = await fetch(`${apiUrl}/setup-state/sis-request`, {
    method: 'POST',
    headers: authHeaders(token),
  });
  if (!response.ok) {
    throw new Error(`setup-state sis-request failed: ${response.status}`);
  }
}
